export default function PolicyCostData() {
    return {
        text: {
                title: "How much will your policy cost",
                paragraphs: [
                  "There are several factors that determine your price for coverage. In addition to coverage amount and coverage duration, the insurance companies will review your age, gender, and health as well as financial and lifestyle background to evaluate your risk classification which drives your final price.",
                  "Our licensed, non-commissioned experts have your best interests in mind and will help you secure the right company and coverage to fit in your budget."
              ],
            },
        callToActionText: "Continue",
        image: "/product-landing/term/policy-cost.jpg",
    };
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/WholeLife/PolicyCostData.js